import React from 'react';
import { Link } from 'react-router-dom';

const baseChipClasses =
  'flex-none snap-start whitespace-nowrap rounded-full border-2 px-4 py-2.5 text-[15px] font-bold transition-all';

const activeChipClasses = 'border-primary-600 bg-primary-600 text-white shadow-md shadow-primary-600/30 scale-105';
const inactiveChipClasses =
  'border-primary-100 bg-primary-50 text-primary-700 hover:border-primary-500 hover:bg-primary-100';

// Horizontally-scrollable pill chips on mobile (edge-to-edge, snap-scroll),
// wrapping normally once there's enough width to show them all. Chips carry
// their own color even at rest so they read as a nav control on touch
// devices, where hover states never fire.
const SubCategoryChips = ({ categoryId, subCategories, activeSubCategoryId }) => {
  if (!subCategories.length) return null;

  return (
    <div className="relative -mx-4 mb-6 px-4 sm:mx-0 sm:px-0">
      <div className="no-scrollbar flex snap-x gap-2.5 overflow-x-auto py-1.5 sm:flex-wrap sm:overflow-visible sm:py-0">
        <Link
          to={`/category/${categoryId}`}
          className={`${baseChipClasses} ${!activeSubCategoryId ? activeChipClasses : inactiveChipClasses}`}
        >
          All
        </Link>
        {subCategories.map(sc => (
          <Link
            key={sc.id}
            to={`/subcategory/${sc.id}`}
            className={`${baseChipClasses} ${
              String(sc.id) === String(activeSubCategoryId) ? activeChipClasses : inactiveChipClasses
            }`}
          >
            {sc.name}
          </Link>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-gray-50 to-transparent sm:hidden" />
    </div>
  );
};

export default SubCategoryChips;
